import React, { useState } from "react";

function RefreshButton({ onRefresh }) {
    const [loading, setLoading] = useState(false);

    const handleClick = () => {
        setLoading(true);
        onRefresh && onRefresh();
        setTimeout(() => setLoading(false), 2000);
    };

    return (
        <button
            type="button"
            className="refresh-gradient-bg px-5 py-2 ms-2 d-inline-flex align-items-center justify-content-center"
            onClick={handleClick}
            disabled={loading}
        >
            {loading ? (
                <div className="spinner-border spinner-border-sm text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            ) : (
                "Refresh Data"
            )}
        </button>
    );
}

export default RefreshButton;